angular.module('leanlaw').directive('qbAccount', ['$timeout', function ($timeout) {
  return {
    restrict: "EA",
    require: "ngModel",
    replace: true,
    template: require("./views/qbAccount.html"),
    scope: {
      ngModel: "="
    },
    link: function ($scope, element, attrs) {}
  };
}]);